exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".icon-rotate-120 {\n  -webkit-transform: rotate(120deg);\n          transform: rotate(120deg);\n}\n", ""]);

